module.exports = __webpack_public_path__ + "static/fonts/proximasoftsemibold-webfont.56048fd.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/proximasoftsemibold-webfont.ttf
// module id = 1036
// module chunks = 11